import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

import { BrowserNotSupportedComponent } from './components/browser-not-supported/browser-not-supported.component';
import { EventTriggerComponent } from './components/event-trigger/event-trigger.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { NoConnectionComponent } from './components/no-connection/no-connection.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { UserComponent } from './components/user/user.component';

import { AdminGuard } from './guards/admin.guard';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { TimeService } from './services/time.service';

@NgModule({
	declarations: [
		BrowserNotSupportedComponent,
		ForbiddenComponent,
		LoginComponent,
		LogoutComponent,
		NotfoundComponent,
		EventTriggerComponent,
		NoConnectionComponent,
		HeaderComponent,
		UserComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		SharedModule
	],
	exports: [
		HeaderComponent
	],
	providers: [
		AdminGuard,
		CanDeactivateGuard,
		TimeService
	]
})
export class CoreModule { }